/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DomainsControllerFindAllQueryResponse, DomainsControllerFindAllQueryParams, DomainsControllerFindAll401, DomainsControllerFindAll403 } from "../../models/domainsController/DomainsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { domainsControllerFindAll } from "../../clients/domainsService/domainsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const domainsControllerFindAllQueryKey = (params: DomainsControllerFindAllQueryParams) => [{
  url: '/api/v1/domains'
}, ...(params ? [params] : [])] as const;
export type DomainsControllerFindAllQueryKey = ReturnType<typeof domainsControllerFindAllQueryKey>;
export function domainsControllerFindAllQueryOptions(params: DomainsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = domainsControllerFindAllQueryKey(params);
  return queryOptions<DomainsControllerFindAllQueryResponse, ResponseErrorConfig<DomainsControllerFindAll401 | DomainsControllerFindAll403>, DomainsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return domainsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List domains for an organization
 * {@link /api/v1/domains}
 */
export function useDomainsControllerFindAll<TData = DomainsControllerFindAllQueryResponse, TQueryData = DomainsControllerFindAllQueryResponse, TQueryKey extends QueryKey = DomainsControllerFindAllQueryKey>(params: DomainsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<DomainsControllerFindAllQueryResponse, ResponseErrorConfig<DomainsControllerFindAll401 | DomainsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? domainsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...domainsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DomainsControllerFindAll401 | DomainsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}